<template>
  <div class="con">
    <div
      v-for="(item, index) in stepList"
      :key="index"
      :class="
        index === 0 ? 'text_left' : index === 2 ? 'text_right' : 'text_center'
      "
      class="font12 font_weight500 colo087 step step1 line_height_17"
    >
      <div class="step_top">
        <div v-if="index !== 0" class="line"></div>
        <img :src="item.iconUrl" alt="" class="step_img" />
        <div v-if="index !== stepList.length - 1" class="line"></div>
      </div>
      <div class="step_det">{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      stepList3: [
        {
          iconUrl: require(`@/assets/${this.$G("@/")}product/step111@2x.png`),
          name: "正品货源",
        },
        {
          iconUrl: require("@/assets/product/step3@2x.png"),
          name: this.$G("国内仓发货"),
        },
        { iconUrl: require("@/assets/product/step2@2x.png"), name: "快递物流" },
      ],
      stepList1: [
        { iconUrl: require("@/assets/product/step1@2x.png"), name: "全球直采" },
        {
          iconUrl: require("@/assets/product/step3@2x.png"),
          name: this.$G("保税仓发货"),
        },
        {
          iconUrl: require("@/assets/product/step2@2x.png"),
          name: "快递物流",
        },
      ],
      stepList2: [
        {
          iconUrl: require(`@/assets/${this.$G("@/")}product/step111@2x.png`),
          name: "正品货源",
        },
        {
          iconUrl: require("@/assets/product/step3@2x.png"),
          name: this.$G("直邮仓发货"),
        },
        { iconUrl: require("@/assets/product/step2@2x.png"), name: "快递物流" },
      ],
      // stepList: []
    };
  },
  computed: {
    stepList() {
      const { tradeType } = this.$store.getters.mallretailspu;
      if (tradeType == 0) {
        return this.stepList2;
      } else if (tradeType == 1) {
        return this.stepList1;
      } else {
        return this.stepList3;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.con {
  margin-top: 10px;
  background: #fff9f9;
  border-radius: 6px 6px 0px 0px;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 10px 20px;
  .step {
    flex: 1;
  }
  .step_top {
    display: flex;
    .step_img {
      display: block;
      width: 24px;
      height: 24px;
      margin: 0 10px;
    }
    .line {
      border-bottom: 1px solid rgba(255, 74, 112, 1);
      width: 100%;
      margin-bottom: 10px;
    }
  }
  .step_det {
    margin-top: 8px;
  }
}
</style>
